import { ThemeColor } from '@/enums'
import { Button } from '@surein/ui'
import { ArrowRight } from 'lucide-react'
import { Typography } from '../../atoms'
import { Content, ContentWrapper, EmojiContainer } from './styles'

export interface SuccessViewProps {
  title?: string
  subtitle?: string
  buttonText?: string
  secondaryButtonText?: string
  onButtonClick?: () => void
  onSecondaryButtonClick?: () => void
}

export const SuccessView = ({
  title,
  subtitle,
  buttonText,
  secondaryButtonText,
  onButtonClick,
  onSecondaryButtonClick,
}: SuccessViewProps) => (
  <ContentWrapper>
    <Content>
      <EmojiContainer>🙌</EmojiContainer>
      <Typography variant="h3">{title}</Typography>
      <Typography color={ThemeColor.b50} variant="p1Body">
        {subtitle}
      </Typography>
      <Button
        suffixIcon={ArrowRight}
        onClick={onButtonClick}
        shape="square"
        variant="primary"
      >
        {buttonText}
      </Button>
      {secondaryButtonText && (
        <Button onClick={onSecondaryButtonClick} variant="muted" shape="square">
          {secondaryButtonText}
        </Button>
      )}
    </Content>
  </ContentWrapper>
)
